import React from 'react';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { OUTLINE_COLOR } from '../constants';

const useStyles = makeStyles((theme) => ({
  root: {
    letterSpacing: 1.6,
    fontWeight: 'bold',
    fontFamily: 'Montserrat, sans-serif',
    display: 'inline-block',
    color: 'white',
    textShadow: `1px 1px 1px ${OUTLINE_COLOR}, -1px 1px 1px ${OUTLINE_COLOR}, 1px -1px 1px ${OUTLINE_COLOR}, -1px -1px 1px ${OUTLINE_COLOR}, 1px  0px 1px ${OUTLINE_COLOR}, 0px  1px 1px ${OUTLINE_COLOR}, -1px  0px 1px ${OUTLINE_COLOR}, 0px -1px 1px ${OUTLINE_COLOR}`,
  },
}));

const OutlinedTypography = ({ children, classes }) => {
  const typographyClasses = useStyles({ classes });
  return <Typography className={typographyClasses.root}>{children}</Typography>;
};

export default OutlinedTypography;
